<template>
  <div id="contents" class="home">
    <div id="main" class="home">
      <div class="home">
        <slide-show />
        <div id="contents">
          <update-info />
          <section>
            <main-content
              v-for="content in contentList"
              :key="content.id"
              v-bind:content="content"/>
          </section>
        </div>
      </div>
    </div><!--/main-->
    <!-- <sub-menu-list/> -->
  </div><!--/contents-->
</template>

<script>
import Content from '@/components/Content'
import SubMenuList from '@/components/SubMenuList'
import SlideShow from '@/components/SlideShow'
import UpdateInfo from '@/components/UpdateInfo'

export default {
  components: {
    'main-content': Content,
    'sub-menu-list': SubMenuList,
    'slide-show': SlideShow,
    'update-info': UpdateInfo,
  },
  computed: {
    contentList() {
      var published = this.$store.getters.getContentListHome.filter(function(content) {
          return (content.draft == false);
      // return this.$store.getters.getContentListHome;
      });
      return published;
    },
  },
  filters: {
    addComma: function (value) {
      return value.toLocaleString();
    },
    addNewLine: function (value) {
      return value.replace(/\r?\n/g, '<br>');
    },
    convertBullet: function (value) {
      return '<ul><li>' + value.replace(/\r?\n/g, '</li><li>') + '</li></ul>';
    },
  },
  head: {
    title: {
      inner: 'たちかわ演劇祭',
      // innerに入力したものがタイトルになりますが、separatorとcomplementを使用すると「タイトル | 捕捉」のようになります。
      // トップページ以外でよく見ますね。不要な場合は省略可能です。
      separator: ' ',
      complement: ' '
    },
    meta: function () {
      const title = 'たちかわ演劇祭'
      const description = '' + 'たちかわ演劇祭は東京都立川市で毎年開催している演劇イベントです。多摩地域で活躍している劇団と市民スタッフを中心として、演劇を観る楽しさ、創る楽しさを多くの人に体験してもらう活動を続けています。'
      const keywords = 'たちかわ演劇祭 立川演劇祭 立川 たちかわ 演劇 祭 チケット 舞台 芝居 ミュージカル オペラ おすすめ たましん risuru リスル ホール'
      return [
        { name: 'description', content: description },
        { name: 'viewport', content: 'width=device-width,initial-scale=1.0,user-scalable=no' },
        { charset: 'utf-8' },
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { name: 'description', content: description },
        { name: 'keywords', content: keywords },
        { name: 'google-site-verification', content: 'XkXq13mDB76ucoVc15CoQ8uc2b7jXOQO582pV8fTAMQ' },
      ]
    },
    link: [
      // { rel: 'stylesheet', href: '外部cssファイル' },
      // { rel: 'shortcut icon', href: 'ファビコン' },
      { rel: 'stylesheet', href: 'https://cdn.jsdelivr.net/npm/zoom-vanilla.js/dist/zoom.css' },
    ],
    script: [
      // { type: 'text/javascript', src: '外部jsファイル', async: true},
      // body内に挿入したい場合は「body: true」を入れましょう
      // { type: 'text/javascript', src: '外部jsファイル', async: true, body: true},
      // { type: 'text/javascript', src: 'https://cdn.jsdelivr.net/npm/zoom-vanilla.js/dist/zoom-vanilla.min.js', async: true, body: true},
    ]
  },
};
</script>
